import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { engagementModels } from '../../data/mock';

export const EngagementModelsSection = () => {
  return (
    <section id="engagement" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            Engagement Models
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            Flexible Partnership Options
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Choose the engagement model that best fits your project requirements and business goals.
          </p>
        </div>

        {/* Models Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {engagementModels.map((model, i) => (
            <div
              key={i}
              className={`relative rounded-2xl p-8 transition-all duration-300 ${
                i === 1
                  ? 'bg-[#1e3a5f] text-white shadow-2xl scale-105'
                  : 'bg-gray-50 hover:shadow-xl'
              }`}
            >
              {i === 1 && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-[#f26522] text-white text-sm font-medium rounded-full">
                  Most Popular
                </div>
              )}

              <h3 className={`text-2xl font-bold mb-3 ${i === 1 ? 'text-white' : 'text-[#1e3a5f]'}`}>
                {model.title}
              </h3>
              <p className={`mb-6 ${i === 1 ? 'text-white/80' : 'text-gray-600'}`}>
                {model.description}
              </p>

              {/* Features */}
              <ul className="space-y-3 mb-6">
                {model.features.map((feature, j) => (
                  <li key={j} className="flex items-start">
                    <Check className={`w-5 h-5 mr-3 flex-shrink-0 ${i === 1 ? 'text-[#f26522]' : 'text-[#f26522]'}`} />
                    <span className={i === 1 ? 'text-white/90' : 'text-gray-600'}>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Best For */}
              <div className={`p-4 rounded-xl mb-6 ${i === 1 ? 'bg-white/10' : 'bg-white'}`}>
                <span className={`text-sm font-medium ${i === 1 ? 'text-[#f26522]' : 'text-[#f26522]'}`}>
                  Best for:
                </span>
                <p className={`text-sm mt-1 ${i === 1 ? 'text-white/80' : 'text-gray-600'}`}>
                  {model.bestFor}
                </p>
              </div>

              {/* CTA */}
              <button
                onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                className={`w-full py-3 rounded-lg font-medium transition-all flex items-center justify-center ${
                  i === 1
                    ? 'bg-[#f26522] hover:bg-[#d95a1b] text-white'
                    : 'bg-[#1e3a5f] hover:bg-[#152a45] text-white'
                }`}
              >
                Get Started
                <ArrowRight className="ml-2 w-4 h-4" />
              </button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Not sure which model is right for you?</p>
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center text-[#f26522] font-medium hover:text-[#d95a1b] transition-colors"
          >
            Let's discuss your requirements
            <ArrowRight className="ml-2 w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
